<template>
    
</template>

<script>
    export default {
        name: "simple-weekly-schedule-time"
    }
</script>

<style scoped>

</style>